module.exports = __webpack_public_path__ + "img/menu-banner-commrisk-assist.e8d7a166.png";